import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { useTranslator } from '@bluebeam/react-i18n';
import { GeneralIcons } from '@bluebeam/react-skyline-art';
import { IconButton } from '@bluebeam/react-skyline-icon-button';
import { DialogContent as DialogContentReach, DialogOverlay } from '@reach/dialog';
import { useEffect, useRef } from 'react';
import DialogContent from './DialogContent';
import { DialogContextProvider } from './DialogContextProvider';
import DialogFooter from './DialogFooter';
import { useDialogContext } from './useDialogContext';
const Dialog = ({ ariaClose, className, overlayClassName, initialFocusRef, title, children, onDismiss, size, ...rest }) => {
    const headerRef = useRef(null);
    const dialogRef = useRef(null);
    const { setDialogRef, setHeaderRef, titleId } = useDialogContext();
    const { translate } = useTranslator(['local']);
    const dataAttributes = useDataAttributes(rest);
    useEffect(() => {
        setHeaderRef(headerRef);
    }, [headerRef, setHeaderRef]);
    useEffect(() => {
        setDialogRef(dialogRef);
    }, [dialogRef, setDialogRef]);
    const dismissKeyboardOnly = (e) => {
        if (e.nativeEvent.type === 'click') {
            return;
        }
        onDismiss && onDismiss();
    };
    return (_jsx(DialogOverlay, { className: buildClassName(`bb-dialog flex flex-col justify-center bb-dialog--${size}`, overlayClassName), initialFocusRef: initialFocusRef, isOpen: true, onDismiss: dismissKeyboardOnly, children: _jsxs(DialogContentReach, { "aria-labelledby": titleId, className: buildClassName('elevation-3 flex flex-col', className), ref: dialogRef, ...dataAttributes, children: [_jsxs("header", { className: buildClassName('bg-markup-white flex shrink-0 items-center justify-between', 'h-16 max-w-full rounded-t-lg px-6 py-2 text-left'), ref: headerRef, children: [_jsx("h2", { className: "skyline-text-subtitle-1 m-0 font-bold text-black", id: titleId, children: title }), onDismiss && (_jsx(IconButton, { "aria-label": ariaClose === undefined ? translate('local:close') : ariaClose, onClick: onDismiss, type: "button", variant: "text", children: _jsx(GeneralIcons.CloseIcon, { className: "text-darker-gray", size: "24px" }) }))] }), children] }) }));
};
/**
 * A dialog is a type of **molecule** that combines a `<DialogFooter />` component with a `<DialogContent />` component to display inside a window over the top of the page.
 */
const DialogContainer = (props) => {
    return (_jsx(DialogContextProvider, { children: _jsx(Dialog, { ...props }) }));
};
DialogContainer.Content = DialogContent;
DialogContainer.Footer = DialogFooter;
export default DialogContainer;
//# sourceMappingURL=Dialog.js.map